import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import {
  reportsAvailable,
  REPORTS_WITH_CUSTOMER,
  REPORTS_WITH_PLATFORM,
  REPORTS_WITH_LINK_STATUS,
  REPORTS_WITH_DATES,
  REPORTS_WITH_DATE_FIELD
} from './reportConfig'

export const useReportForm = (reportId, setReportId, submitReportRequest) => {
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      customer: '',
      platform: '',
      start_date: '',
      end_date: '',
      report_name: '',
      link_status: '',
      date_field: ''
    },
    validationSchema: Yup.object({
      customer: REPORTS_WITH_CUSTOMER.includes(reportId)
        ? Yup.string().required('Please select customer')
        : Yup.string().nullable(),
      platform: REPORTS_WITH_PLATFORM.includes(reportId)
        ? Yup.string().required('Please select platform')
        : Yup.string().nullable(),
      link_status: REPORTS_WITH_LINK_STATUS.includes(reportId)
        ? Yup.string().required('Please select Link Status')
        : Yup.string().nullable(),
      start_date: REPORTS_WITH_DATES.includes(reportId)
        ? Yup.date().required('Start date is required')
        : Yup.date().nullable(),
      end_date: REPORTS_WITH_DATES.includes(reportId)
        ? Yup.date()
            .min(
              Yup.ref('start_date'),
              "End Date can't be before the Start Date."
            )
            .required('End date is required')
        : Yup.date().nullable(),
      date_field: REPORTS_WITH_DATE_FIELD.includes(reportId)
        ? Yup.string().required('Please select a date field')
        : Yup.string().nullable(),
      report_name: Yup.string().required('Please select a report')
    }),
    onSubmit: async (values, { resetForm }) => {
      const reportConfig = reportsAvailable.find(item => item.id === reportId)
      if (!reportConfig) {
        toast.error('Please select a valid report')
        return
      }

      const params = {}

      if (values.customer && values.customer !== '*') {
        params.customer = values.customer
      }

      if (values.platform && values.platform !== '*') {
        params.platform = values.platform
      }

      if (values.start_date) {
        params.start_date = values.start_date
      }

      if (values.end_date) {
        params.end_date = values.end_date
      }

      if (values.link_status) {
        params.link_status = values.link_status
      }

      if (values.date_field) {
        params.date_field = values.date_field
      }

      const payload = {
        report_type: reportConfig.report_type,
        params
      }

      try {
        await submitReportRequest(payload).unwrap()
        toast.success(
          'Report request submitted successfully! You can check report below.'
        )
        resetForm()
        setReportId(null)
      } catch (err) {
        if (err?.data) {
          const errorMessages = Object.values(err.data).flat()
          errorMessages.forEach(message => {
            toast.error(message)
          })
        } else {
          toast.error('Failed to submit report request')
        }
      }
    }
  })

  const handleSubmit = async () => {
    const errors = await validation.validateForm()
    if (Object.keys(errors).length > 0) {
      validation.setTouched(
        Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {})
      )
      Object.values(errors).forEach(msg => toast.error(msg))
      return
    }
    validation.handleSubmit()
  }

  return { ...validation, handleSubmit }
}
